import { formatCost as formatCostDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

type FormatCostProps = {
    cost: number;
}

export const formatCost = ({ cost }: FormatCostProps): string =>
    formatCostDiagram(cost);
